// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"cart-recommendation-section-v2_titleContainer__C9KKX","title":"cart-recommendation-section-v2_title__fiHuj"};